var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('outlined-icon',_vm._b({staticClass:"icon",attrs:{"iconSize":"md","name":"fal fa-angle-left"},on:{"click":_vm.onClick}},'outlined-icon',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }